export const environment = {
  production: false,
  chatbotUrl: "https://stage.bot.wizefulfill.com/",
  baseUrl: "https://api.testing.wizefulfill.com/",
  sellerCloudUrl: "https://shtiks.api.sellercloud.com/rest/api/",
  // authServiceUrl: "https://api.testing.wizefulfill.com/auth_service",
  // clientServiceUrl: "https://api.testing.wizefulfill.com/client_service",
  // spServiceUrl: "https://api.testing.wizefulfill.com/wms_service",

  authServiceUrl: 'http://localhost:3000',
  clientServiceUrl: 'http://localhost:3001',
  spServiceUrl: 'http://localhost:3001',

  
  hubspot: {
    portalId: "45268756",
    hublet: "na1",
    environment: "prod",
    defaultChatFlow: "mobilechat",
  }
};